module.exports = __webpack_public_path__ + "assets/fdd2fa4948a3a0cf66304863353d46cd.png";